module.exports = __webpack_public_path__ + "img/15pll.b6773133.png";